module.exports = __webpack_public_path__ + "img/contact-img.7ff8abf2.svg";